import {Checkbox, FormControl} from '@primer/react'

import {ActorSelector} from './ActorSelector'
import type {RegisteredRuleSchemaComponent} from '@github-ui/repos-rules-types/rules-types'

export function DismissalRestriction({
  field,
  value,
  onValueChange,
  readOnly,
  metadata,
  errors,
  queryMetadata,
  sourceType,
  rulesetId,
  helpUrls,
  fieldRef,
}: RegisteredRuleSchemaComponent) {
  const current = (value ?? {}) as {enabled?: boolean; allowed_actors?: string[]}
  const enabled = Boolean(current.enabled)
  const allowedActors = Array.isArray(current.allowed_actors) ? current.allowed_actors : []

  const allowedActorsField = field.type === 'object' ? field.fields?.find(f => f.name === 'allowed_actors') : undefined
  if (!allowedActorsField) {
    throw new Error('DismissalRestriction: schema is missing the nested allowed_actors field')
  }

  return (
    <div>
      <FormControl disabled={readOnly}>
        <Checkbox
          checked={enabled}
          onChange={e =>
            onValueChange({enabled: e.target.checked, allowed_actors: e.target.checked ? allowedActors : []})
          }
          ref={fieldRef as React.Ref<HTMLInputElement> | undefined}
        />
        <FormControl.Label>{field.display_name}</FormControl.Label>
        {field.description ? <FormControl.Caption>{field.description}</FormControl.Caption> : null}
      </FormControl>
      {enabled ? (
        <div className="ml-4 mt-2">
          <ActorSelector
            sourceType={sourceType}
            rulesetId={rulesetId}
            helpUrls={helpUrls}
            field={allowedActorsField}
            value={allowedActors}
            onValueChange={next =>
              onValueChange({enabled, allowed_actors: Array.isArray(next) ? (next as string[]) : []})
            }
            readOnly={readOnly}
            metadata={metadata}
            errors={errors}
            queryMetadata={queryMetadata}
          />
        </div>
      ) : null}
    </div>
  )
}
